'use client'

import { faRightToBracket, faUserPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from '@ui/Button/Button'
import { type AuthTab } from '@view/auth/model'

import { authTexts } from '../auth-texts'
import styles from './styles.module.css'

interface SwitchAuthCalloutProps {
  tab: AuthTab
  onSwitch: () => void
}

export const SwitchAuthCallout = ({ tab, onSwitch }: SwitchAuthCalloutProps) => {
  const { callout } = authTexts[tab]
  const icon = tab === 'login' ? faUserPlus : faRightToBracket

  return (
    <div
      className={
        styles.container + ' mt-6 rounded-lg bg-indigo-50 p-4 text-center border border-blue-400 dark:bg-gray-700'
      }
    >
      <p className="font-bold text-indigo-600 dark:text-indigo-300">{callout.title}</p>
      <p className="mb-3 text-sm text-gray-500 dark:text-gray-400">{callout.description}</p>
      <Button className={styles.button} type="button" view={'secondary'} fullWidth onClick={onSwitch}>
        <FontAwesomeIcon width={16} height={16} icon={icon} className={styles.icon + ' mr-2'} />
        {callout.action}
      </Button>
    </div>
  )
}
